<app-modal-shell
  data-cy="ticket-mandate-holder-modal-title"
  [title]="'TICKETS.MANDATE_HOLDER_INFORMATION.TITLE'"
  [cancelLabel]="'SET_IBAN.BUTTONS.CANCEL'"
  [saveLabel]="'SET_IBAN.BUTTONS.OK'"
  (cancelClicked)="cancel()"
  (saveClicked)="save()">

  <div class="form-group">
    @if(formReady){
    <form  [id]="'mandateHolderForm'" [formGroup]="this.form">
     <app-custom-input
        [customFormGroup]="this.form"
        [id]="'mandateHolderFirstname'"
        [label]="PFLICHTFELDMARKER + ('TICKETS.MANDATE_HOLDER_INFORMATION.FIRSTNAME' | translate)"
        data-cy="mandateHolderFirstname">
      </app-custom-input>
      <app-custom-input
        [customFormGroup]="this.form"
        [id]="'mandateHolderLastname'"
        [label]="PFLICHTFELDMARKER + ('TICKETS.MANDATE_HOLDER_INFORMATION.LASTNAME' | translate)"
        data-cy="mandateHolderLastname">
      </app-custom-input>
      <app-custom-input
        id="mandateHolderDateOfBirth"
        type="date"
        [customFormGroup]="this.form"
        [label]="PFLICHTFELDMARKER + ('TICKETS.MANDATE_HOLDER_INFORMATION.DATE_OF_BIRTH' | translate)"
        data-content="dd.mm.yyyy"
        data-cy="mandateHolderDateOfBirth"
      ></app-custom-input>
      <app-custom-input
        [customFormGroup]="this.form"
        [id]="'mandateHolderStreet'"
        [label]="PFLICHTFELDMARKER + ('TICKETS.MANDATE_HOLDER_INFORMATION.STREET' | translate)"
        data-cy="mandateHolderStreet">
      </app-custom-input>
      <app-custom-input
        [customFormGroup]="this.form"
        [id]="'mandateHolderPostalCode'"
        [label]="PFLICHTFELDMARKER + ('TICKETS.MANDATE_HOLDER_INFORMATION.POSTAL_CODE' | translate)"
        [pattern]="getPlzPattern('mandateHolderCountry')"
        [maxlength]="getMaxPlzLength('mandateHolderCountry')"
        data-cy="mandateHolderPostalCode">
      </app-custom-input>
      <app-custom-input
        [customFormGroup]="this.form"
        [id]="'mandateHolderCity'"
        [label]="PFLICHTFELDMARKER + ('TICKETS.MANDATE_HOLDER_INFORMATION.CITY' | translate)"
        data-cy="mandateHolderCity">
      </app-custom-input>
      <app-custom-select
        id="mandateHolderCountry"
        [class]="'sfk-ellipsed-ng-select'"
        [customFormGroup]="this.form"
        [items]="countryList"
        [multiple]="false"
        [clearable]="false"
        bindLabel="value"
        bindValue="name"
        [label]="PFLICHTFELDMARKER + ('TICKETS.MANDATE_HOLDER_INFORMATION.COUNTRY' | translate)"
        data-cy="mandateHolderCountry"
        (onchange)="setPlzPatternValidator('mandateHolderPostalCode', 'mandateHolderCountry')"
      ></app-custom-select>
      <app-custom-input
        [customFormGroup]="this.form"
        [id]="'mandateHolderBankName'"
        [label]="PFLICHTFELDMARKER + ('TICKETS.MANDATE_HOLDER_INFORMATION.BANK_NAME' | translate)"
        data-cy="mandateHolderBankName">
      </app-custom-input>
      <app-custom-input
        [customFormGroup]="this.form"
        [id]="'mandateHolderIban'"
        [label]="PFLICHTFELDMARKER + ('TICKETS.MANDATE_HOLDER_INFORMATION.IBAN' | translate)"
        data-cy="mandateHolderIban">
      </app-custom-input>
      <app-custom-input
        [customFormGroup]="this.form"
        [id]="'mandateHolderBic'"
        [label]="bicRequiredMarker + ('TICKETS.MANDATE_HOLDER_INFORMATION.BIC' | translate)"
        data-cy="mandateHolderBic">
      </app-custom-input>
      <app-custom-checkbox
        [id]="'mandateHolderSepaMandateAccepted'"
        [customFormGroup]="this.form"
        [label]="PFLICHTFELDMARKER + ('TICKETS.MANDATE_HOLDER_INFORMATION.SEPA_MANDATE_ACCEPTED' | translate)"
        [title] = "'TICKETS.MANDATE_HOLDER_INFORMATION.SEPA_MANDATE_TITLE' | translate"
      ></app-custom-checkbox>
    </form>
    }
  </div>

</app-modal-shell>
